import udj1 from "../../public/static/images/svg/belanja-di-toko/UDJ1.svg";
import udj2 from "../../public/static/images/svg/belanja-di-toko/UDJ2.svg";
import udj3 from "../../public/static/images/svg/belanja-di-toko/UDJ3.svg";
import udj4 from "../../public/static/images/svg/belanja-di-toko/UDJ4.svg";
import udj5 from "../../public/static/images/svg/belanja-di-toko/UDJ5.svg";
import udj6 from "../../public/static/images/svg/belanja-di-toko/UDJ6.svg";

export const DataBelanjaDiToko = [
  { img: udj1, desc: "Download aplikasi My Home Credit" },
  {
    img: udj2,
    desc: "Scan QR code di toko / dari Tim Home Credit dan ikuti prosesnya"
  },
  { img: udj3, desc: "Upload Dokumen (KTP, Selfie, Dokumen Pendukung)" },
  {
    img: udj4,
    desc:
      "Lengkapi data dirimu & tunggu sekitar 1 menit untuk dapetin limit pembiayaan"
  },
  {
    img: udj5,
    desc:
      "Pilih barang yang kamu mau & ajukan cicilannya di toko mitra Home Credit"
  },
  {
    img: udj6,
    desc:
      "Jika pengajuanmu disetujui, baca dan tandatangani kontrak, lalu bayar DP & biaya admin"
  }
];
